import React from 'react';

import CardDesign from '../CommonComponents/CardDesign';

export default function CommerceSection({ handleLinkClick, CommerceData, isLoading }) {
  return (
    <div className="bg-[#f7f7f7] pt-5 md:pt-10">
      <CardDesign
        initialModuleName=""
        cardType="commerce"
        data={CommerceData}
        handleLinkClick={handleLinkClick}
        showArrow={false}
      />
    </div>
  )
}